function isPromise(value) {
    return value && typeof value.then === 'function';
}

function isMessagePlusInterpolation(value) {
    return value && typeof value.key === 'string';
}

export default ['$scope', '$filter', '$translate', '$q', 'model', 'stateProps', function ($scope, $filter, $translate, $q, model, stateProps) {
    function translate(val) {
        if (isPromise(val)) {
            return val;
        }
        if (isMessagePlusInterpolation(val)) {
            return $translate(val.key, val.args || {});
        }
        return $q.when(typeof val === 'string' && val.length ? $translate(val) : val);
    }

    function writeToScope(prop) {
        return function (msg) {
            $scope[prop] = msg;
        };
    }

    $scope.iconClass = function () {
        switch (model.iconClass) {
            case 'gw-messageErrorIcon':
                return 'fa fa-minus-circle';
            case 'gw-messageWarningIcon':
                return 'fa fa-exclamation-triangle';
            case 'gw-messageInformationIcon':
                return 'fa fa-info-circle';
            case 'gw-messageEmailIcon':
                return 'fa fa-envelope-o';
            default:
                return null;
        }
    };

    $scope.iconClassType = function () {
        return model.iconClass;
    };

    $scope.stateProps = stateProps;
    $scope.showCancelBtn = model.showCancelBtn;
    $scope.cancelBtnLabel = model.cancelBtnLabel;

    if (model.radioOptions && model.radioOptions.length > 0) {
        $scope.radioOptions = model.radioOptions;
        $scope.optionsModel = {
            set value(code) {
                this.code = { code: code };
            },
            get value() {
                return this.code;
            },
            aspects: {
                visible: true,
                get valid() {
                    return $scope.optionsModel.value && $scope.optionsModel.value.code;
                }
            }
        };
        $scope.optionsModel.value = model.radioOptions[0].value;
    }

    if (model.checkboxOptions) {
        $scope.checkboxOptions = model.checkboxOptions;
        $scope.optionsModel = {
            'value': model.checkboxOptions.value
        };
    }

    $scope.toggle = function ($event) {
        $event.stopPropagation();
        $scope.optionsModel.value = !$scope.checkboxOptionsModel.value;
    };

    translate(model.title).then(writeToScope('title'));
    translate(model.message).then(writeToScope('message'));
    translate(model.description).then(writeToScope('description'));

    if (model.action) {
        $scope.action = {
            btnClass: model.action.btnClass || 'gw-btn-primary',
            label: model.action.label || $filter('translate')('platform.modal.ModalCtrl.OK')
        };
    }
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/modal/ModalCtrl.js
// module id = 1127
// module chunks = 0